module.exports = ".cancel{height:2rem}"